import { UserState } from './states/user.state'
import { EventState } from './states/event.state'

export * from './states/user.state'
export * from './actions/user.actions'
    

export const APP_STATES = [UserState, EventState]
